/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
import { checklistReducerConstant } from '../../reducerConstant';

const initialState = {
  model: null,
  childModel: null,
  completedProjects: null,
  completedChecklist: null,
  completedSection: null,
  checklist: null,
  assembly: null,
  tagslist: null,
  assemblydatavalues: null,
  componentsdatavalues: null,
  addComponentData: null,
  singlecheckliststore: null,
  severityliststore: null,
  sectionliststore: null,
  taskliststore: null,
  modeldataliststore: null,
  modelparticulartreeliststore: null,
  reporttemplatelist: null,
  ChecklistGetSeveritySetNames: null,
  ischecklistseveritysetcreated: null,
  getallchecklistinfoblocks: null,
  getallchecklistworkplans: null,
  ischecklistcreated: null,
  isinfoblockcreated: null,
  isinfoblockdeleted: null,
  isworkplancreated: null,
  isworkdeleted: null,
  taskworkplan: null,
  sectionworkplan: null,
  istaskmapped: null,
  indicator: false,
  isEditModel: false,
  isEditChecklist: false,
  isEditSection: false,
  isEditTask: false,
  isEditAssembly: false,
  isEditComponent: false,
  isAssembly: false,
  checklistReportsList: null,
  severityRatingSetList: null,
  reportsBySeverity: null,
  reportsForArchived: null,
  checklistFilterData: null,
};

const checklistReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case checklistReducerConstant.COMPLETE_TREE:
      return {
        ...state,
        completeTree: action.value,
      };
    case checklistReducerConstant.MODEL_LIST:
      return {
        ...state,
        model: action.value,
        indicator: false,
        isEditModel: false,
        isEditChecklist: false,
        isEditSection: false,
        isEditTask: false,
        isEditAssembly: false,
        isEditComponent: false,
      };
    case checklistReducerConstant.LIST:
      return {
        ...state,
        childModel: action.value,
        isAssembly: false,
        indicator: false,
        isEditModel: false,
        isEditChecklist: false,
        isEditSection: false,
        isEditTask: false,
        isEditAssembly: false,
        isEditComponent: false,
      };
    case checklistReducerConstant.RENAME_LIST:
      return {
        ...state,
        childModel: action.value,
        isAssembly: true,
        indicator: false,
        isEditModel: false,
        isEditChecklist: false,
        isEditSection: false,
        isEditTask: false,
        isEditAssembly: false,
        isEditComponent: false,
      };
    case checklistReducerConstant.COMPLETED_PROJECTS:
      return {
        ...state,
        completedProjects: action.value,
        indicator: false,
        isEditModel: false,
        isEditChecklist: false,
        isEditSection: false,
        isEditTask: false,
        isEditAssembly: false,
        isEditComponent: false,
      };
    case checklistReducerConstant.COMPLETED_CHECKLIST_LIST:
      return {
        ...state,
        completedChecklist: action.value,
        indicator: false,
        isEditModel: false,
        isEditChecklist: false,
        isEditSection: false,
        isEditTask: false,
        isEditAssembly: false,
        isEditComponent: false,
      };
    case checklistReducerConstant.COMPLETED_SECTION_LIST:
      return {
        ...state,
        completedSection: action.value,
        indicator: false,
        isEditModel: false,
        isEditChecklist: false,
        isEditSection: false,
        isEditTask: false,
        isEditAssembly: false,
        isEditComponent: false,
      };
    case checklistReducerConstant.CHECKLIST_LIST:
      return {
        ...state,
        checklist: action.value,
        indicator: false,
        isEditModel: false,
        isEditChecklist: false,
        isEditSection: false,
        isEditTask: false,
        isEditAssembly: false,
        isEditComponent: false,
      };
    case checklistReducerConstant.ASSEMBLY_LIST:
      return {
        ...state,
        assembly: action.value,
        indicator: false,
        isEditModel: false,
        isEditChecklist: false,
        isEditSection: false,
        isEditTask: false,
        isEditAssembly: false,
        isEditComponent: false,
      };
    case checklistReducerConstant.TOGGLE_INDICATOR:
      return {
        ...state,
        indicator: action.value,
      };
    case checklistReducerConstant.ADD_MODEL_LIST:
      return {
        ...state,
        model: action.value,
        indicator: false,
        isEditModel: true,
        isEditChecklist: false,
        isEditSection: false,
        isEditTask: false,
        isEditAssembly: false,
        isEditComponent: false,
      };
    case checklistReducerConstant.ADD_CHECKLIST_LIST:
      return {
        ...state,
        childModel: action.value,
        indicator: false,
        isEditModel: false,
        isEditChecklist: true,
        isEditSection: false,
        isEditTask: false,
        isEditAssembly: false,
        isEditComponent: false,
      };
    case checklistReducerConstant.ADD_SECTION_LIST:
      return {
        ...state,
        checklist: action.value,
        indicator: false,
        isEditModel: false,
        isEditChecklist: false,
        isEditSection: true,
        isEditTask: false,
        isEditAssembly: false,
        isEditComponent: false,
      };
    case checklistReducerConstant.ADD_TASK_LIST:
      return {
        ...state,
        checklist: action.value,
        indicator: false,
        isEditModel: false,
        isEditChecklist: false,
        isEditSection: false,
        isEditTask: true,
        isEditAssembly: false,
        isEditComponent: false,
      };
    case checklistReducerConstant.ADD_ASSEMBLY_LIST:
      return {
        ...state,
        childModel: action.value,
        indicator: false,
        isEditModel: false,
        isEditChecklist: false,
        isEditSection: false,
        isEditTask: false,
        isEditAssembly: true,
        isEditComponent: true,
      };
    case checklistReducerConstant.ADD_COMPONENT_LIST:
      return {
        ...state,
        assembly: action.value,
        indicator: false,
        isEditModel: false,
        isEditChecklist: false,
        isEditSection: false,
        isEditTask: false,
        isEditAssembly: false,
        isEditComponent: true,
      };
    case checklistReducerConstant.CHECKLIST_REPORTS_FOR_DELETE:
      return {
        ...state,
        checklistReportsList: action.value,
      };
    case checklistReducerConstant.SEVERITY_RATING_SET_LIST:
      return {
        ...state,
        severityRatingSetList: action.value,
      };
    case checklistReducerConstant.REPORTS_BY_SEVERITY:
      return {
        ...state,
        reportsBySeverity: action.value,
      };
    case checklistReducerConstant.REPORTS_FOR_ARCHIVED:
      return {
        ...state,
        reportsForArchived: action.value,
      };

    case 'TAGSLIST':
      return {
        ...state,
        tagslist: action.value,
      };
    case 'Add_NEW_TAG':
      return {
        ...state,
        newTag: action.value,
      };
    case 'UPDATE_TAG':
      return {
        ...state,
        updateTag: action.value,
      };
    case 'CLEAR_UPDATE_TAG':
      return {
        ...state,
        updateTag: '',
      };
    case 'CLEAR_NEW_TAG':
      return {
        ...state,
        newTag: '',
      };
    case 'ASSEMBLYDATA':
      return {
        ...state,
        assemblydatavalues: action.value,
      };
    case 'COMPONENTSDATA':
      return {
        ...state,
        componentsdatavalues: action.value,
      };
    case 'ASSEMBLYDATAADD':
      return {
        ...state,
        addComponentData: action.value,
      };
    case 'SINGLECHECKLIST':
      return {
        ...state,
        singlecheckliststore: action.value,
        ischecklistseveritysetcreated: null,
        isinfoblockcreated: null,
        isinfoblockdeleted: null,
        isworkdeleted: null,
      };
    case 'SEVERITYLIST':
      return {
        ...state,
        severityliststore: action.value,
      };
    case 'SECTIONLIST':
      return {
        ...state,
        sectionliststore: action.value,
      };
    case 'GET_SECTION_TYPES':
      return {
        ...state,
        getSectionTypes: action.value,
      };
    case 'TASKSLIST':
      return {
        ...state,
        taskliststore: action.value,
      };
    case 'GETMODELDATALIST':
      return {
        ...state,
        modeldataliststore: action.value,
        ischecklistcreated: null,
      };
    case 'GETMODELTREELIST':
      return {
        ...state,
        modelparticulartreeliststore: action.value,
      };
    case 'GETREPORTTEMPLATELIST':
      return {
        ...state,
        reporttemplatelist: action.value,
      };
    case 'CHECKLISTCREATED':
      return {
        ...state,
        ischecklistcreated: action.value,
      };
    case 'INFOBLOCKCREATED':
      return {
        ...state,
        isinfoblockcreated: action.value,
      };
    case 'INFOBLOCKDELETED':
      return {
        ...state,
        isinfoblockdeleted: action.value,
      };
    case 'WORKPLANCREATED':
      return {
        ...state,
        isworkplancreated: action.value,
      };
    case 'WORKPLANDELETED':
      return {
        ...state,
        isworkdeleted: action.value,
      };
    case 'TASKMAPPED':
      return {
        ...state,
        istaskmapped: action.value,
      };
    case 'GETALLTASKWORKPLAN':
      return {
        ...state,
        taskworkplan: action.value,
      };
    case 'GETALLSECTIONWORKPLAN':
      return {
        ...state,
        sectionworkplan: action.value,
        istaskmapped: null,
      };
    case 'CHECKLISTGETSEVERITYSETNAMES':
      return {
        ...state,
        ChecklistGetSeveritySetNames: action.value,
      };
    case 'GETALLCHECKLISTINFOBLOCKS':
      return {
        ...state,
        getallchecklistinfoblocks: action.value,
      };
    case 'GETALLCHECKLISTWORKPLANS':
      return {
        ...state,
        getallchecklistworkplans: action.value,
        isworkplancreated: null,
      };
    case 'CHECKLISTSEVERITYSETCREATED':
      return {
        ...state,
        ischecklistseveritysetcreated: action.value,
      };
    case 'GET_FAILURE_MODE_SUCCESS':
      return {
        ...state,
        getAllFailureModes: action.value,
      };
    case 'GET_APPLIED_FAILURE_MODE_SUCCESS':
      return {
        ...state,
        getAllAppliedFailureModes: action.value,
      };
    case 'ADD_NEW_FAILURE_MODE_SUCCESS':
      return {
        ...state,
        addFailureSuccess: action.value,
      };
    case 'UPDATE_FAILURE_MODE_SUCCESS':
      return {
        ...state,
        updateFailureModeSuccess: action.value,
      };
    case 'CLEAR_FAILURE_MODE_VALUES':
      return {
        ...state,
        addFailureSuccess: '',
        updateFailureModeSuccess: '',
      };
    case 'GET_FAILURE_MODE_BY_NAME_SUCCESS':
      return {
        ...state,
        getFailureModesByName: action.value,
      };
    case 'STORE_STATUS_SUCCESS':
      return {
        ...state,
        getFailureModesStatus: action.value,
      };
    case 'CLEAR_STORE_STATUS_SUCCESS':
      return {
        ...state,
        getFailureModesStatus: '',
      };
    case 'CHECK_STATUS_SUCCESS':
      return {
        ...state,
        failureStatus: action.value,
        indicator: false,
      };
    case 'CLEAR_FAILURE_SUCCESS': {
      return {
        ...state,
        failureStatus: '',
      };
    }
    case 'CHECKLIST_STATUS': {
      return {
        ...state,
        checklistCreatedSuccess: action.value,
      };
    }
    case 'CLEAR_CHECKLIST_STATUS': {
      return {
        ...state,
        checklistCreatedSuccess: '',
      };
    }
    case 'GET_TAGS_BY_ID_SUCCESS':
      return {
        ...state,
        getTagsById: action.value,
      };
    case 'CLEAR_GET_TAGS_BY_ID':
      return {
        ...state,
        getTagsById: '',
      };
    case 'CHECKLIST_FILTER':
      return {
        ...state,
        checklistFilterData: action.value,
      };
    default:
      return {
        ...state,
      };
  }
};

export default checklistReducer;
